export default [
  {
    path: '/options',
    name: 'options',
    component: () => import('@/views/options/options'),
    meta: { title: '期权' }
  },
  {
    path: '/optionsKLine',
    name: 'optionsKLine',
    component: () => import('@/views/options/kLine'),
    meta: { title: '合约K线图' }
  },
  {
    path: '/optionsOrder',
    name: 'optionsOrder',
    component: () => import('@/views/options/optionsOrder'),
    meta: { title: '我的订单' }
  },
]


// WEBPACK FOOTER //
// ./src/router/config/Options.js